import useBetaRedirectRecheck from "../../hooks/useBetaRedirectRecheck";

// Renders nothing; exists so the re-check hook sits inside the router, where useLocation works.
export default function BetaRedirectRecheck() {
  useBetaRedirectRecheck();
  return null;
}
